export default "__VITE_ASSET__ViPc2gY2__"